import { useState, useEffect } from "react";
import { Form, Col, Row, Modal, Button } from "antd";
import useGet from "../../../global/hooks/useGet";
import usePost from "../../../global/hooks/usePost";
import usePut from "../../../global/hooks/usePut";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import CommonButton from "../../../global/components/CommonButton";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import {
  CheckCircleOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  SendOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import useDelete from "../../../global/hooks/useDelete";
import ConfirmModal from "../../../global/components/ConfirmModal";
import AccountIcon from "../../../assets/images/vectors/SideBarIcons/AccountIcon";
import { AdminInvitation } from "../../../global/components/AdminInvitation";
import AccountForm from "../../../global/components/adminInfo";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import AccountCreationModal from "../../../global/components/AccountCreationModal";
import OemIcon from "../../../assets/images/vectors/SideBarIcons/OemIcon";
import DealerIcon from "../../../assets/images/vectors/SideBarIcons/DealerIcon";
import { GlobalTable } from "../../../global/components/GlobalTable";
import { CustomerAccountColumns } from "../Page/CustomerAccountColumns";
import { SendInvitationForm } from "../../Account/Components/SendInvitationForm";

export const CustomerForm = ({
  type,
  onCancel,
  isModalForm,
  setDefaultData: setAccountDefaultData,
  defaultData: accountDefaultData,
}) => {
  const loggedInUser = JSON.parse(sessionStorage.getItem("userData"));
  const [selectedOemNo, setSelectedOemNo] = useState(loggedInUser?.oem_no);
  const [showModal, setShowModal] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [defaultData, setDefaultData] = useState({
    DealerNo: null,
    OemNo: null,
  });
  const [hoveredRow, setHoveredRow] = useState(null);
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [accountId, setAccountId] = useState(null);
  const [isSendInviteOpen, setIsSendInviteOpen] = useState(false);
  const [isInviteNestedOpen, setIsInviteNestedOpen] = useState(false);
  const [inviteModalType, setInviteModalType] = useState("");

  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const hasCustomerUrl = location.pathname.includes("customer");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const url =
    id && hasCustomerUrl
      ? `${process.env.REACT_APP_API_URL}/api/customers/${id}/`
      : null;
  // oems/<>/dealers/
  const dealerOptionsUrl =
    selectedOemNo || accountDefaultData?.OemNo || defaultData?.OemNo
      ? `${process.env.REACT_APP_API_URL}/api/dealers/oems/${
          accountDefaultData?.OemNo
            ? accountDefaultData?.OemNo
            : defaultData?.OemNo
              ? defaultData.OemNo
              : selectedOemNo
        }/dealers/`
      : null;

  // const dealerOptionsUrl =
  //   selectedOemNo || defaultData?.OemNo
  //     ? `${process.env.REACT_APP_API_URL}/api/dealers/getDealersByOem/${
  //         defaultData?.OemNo ? defaultData.OemNo : selectedOemNo
  //       }/`
  //     : null;
  const postUrl = `${process.env.REACT_APP_API_URL}/api/customers/`;
  // const putUrl = `${process.env.REACT_APP_API_URL}/api/customers/${id}/`;
  // const deleteUrl = `${process.env.REACT_APP_API_URL}/api/customers/${id}/`;
  const optionUrl = `${process.env.REACT_APP_API_URL}/api/accounts/options/`;
  const acountAdmin =
    type === "info" && id
      ? // ? `${process.env.REACT_APP_API_URL}/api/accounts/?AccountType=10&CustomerNo=${id}`
        `${process.env.REACT_APP_API_URL}/api/accounts/?limit=100&AccountTypeIds=10,11,12&CustomerNo=${id}`
      : null;
  const {
    data: adminData,
    loading: adminDataLoading,
    refetch: adminDataRefetch,
  } = useGet(acountAdmin);
  const deleteAdminUrl = `${process.env.REACT_APP_API_URL}/api/accounts/bulk-delete/`;
  const {
    data: deletedAdminData,
    loading: deletedAdminDataLoading,
    error: deletedAdminDataError,
    // deleteData,
    deleteMultiple,
  } = useDelete(deleteAdminUrl);

  // const adminInfo = adminData?.data?.[0];
  const adminInfo =
    adminData?.data?.map((item) => ({ ...item, key: item.AccountNo })) || [];
  const {
    data: optionsData,
    loading: optionDataLoading,
    error: optionDataError,
    refetch: optionDataRefetch,
  } = useGet(optionUrl);
  // const modifiedType = getModifiedResponse(optionsData, "roles");
  // const modifiedDealer = getModifiedResponse(optionsData, "dealers");
  const modifiedOems = getModifiedResponse(optionsData, "oems");
  const { data, loading, error, refetch } = useGet(url);
  const { DealerNo, OemNo } = (data && data.data) || {};

  const {
    data: dealerOp,
    loading: delaerOpLoading,
    error: dealerOpError,
    refetch: delaerOpRefetch,
  } = useGet(dealerOptionsUrl);

  const {
    data: postData,
    loading: postLoading,
    error: postError,
    postData: postAction,
  } = usePost(postUrl);

  const {
    data: putData,
    loading: putLoading,
    error: putError,
    putData: putAction,
  } = usePut(url);
  const {
    data: deletedData,
    loading: deletedDataLoading,
    error: deletedDataError,
    deleteData,
  } = useDelete(url);

  const onFinish = (values) => {
    const modValues = {
      ...values,
      MaxAccount: Number(values.MaxAccount) || undefined,
    };
    try {
      if (id && !isModalForm) {
        if (loggedInUser?.role_value === 7 || loggedInUser?.role_value === 8) {
          const modifiedValues = {
            ...modValues,
            OemNo: loggedInUser?.oem_no,
            DealerNo: loggedInUser?.dealer_no,
          };
          putAction(modifiedValues);
        } else if (
          loggedInUser?.role_value === 4 ||
          loggedInUser?.role_value === 5
        ) {
          const modifiedValues = {
            ...modValues,
            OemNo: loggedInUser?.oem_no,
          };
          putAction(modifiedValues);
        } else {
          putAction(modValues);
        }
      } else {
        if (loggedInUser?.role_value === 7 || loggedInUser?.role_value === 8) {
          const modifiedValues = {
            ...modValues,
            OemNo: loggedInUser?.oem_no,
            DealerNo: loggedInUser?.dealer_no,
          };
          postAction(modifiedValues);
        } else if (
          loggedInUser?.role_value === 4 ||
          loggedInUser?.role_value === 5
        ) {
          const modifiedValues = {
            ...modValues,
            OemNo: loggedInUser?.oem_no,
          };
          postAction(modifiedValues);
        } else {
          postAction(modValues);
        }
      }
    } catch (error) {
      openErrorNotification("Something went wrong.");
      console.log(error);
    }
  };

  const onReset = () => {
    // form.resetFields();
    onCancel ? onCancel() : navigate(-1);
  };

  const onDeleteConfirm = async () => {
    try {
      if (selectedRowKeys.length) {
        await deleteMultiple({ ids: selectedRowKeys });
      } else {
        await deleteData();
      }
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowModal(false);
  };

  useEffect(() => {
    delaerOpRefetch();
  }, [selectedOemNo]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
    // navigate(`/oemlist/${newSelectedRowKeys}`);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    fixed: true,
  };
  const onRow = (record, rowIndex) => {
    return {
      onClick: (event) => {},
    };
  };

  useEffect(() => {
    if (!id || loading) return;
    const getAccountInfoById = () => {
      try {
        form.resetFields();
        if (data?.data) {
          form.setFieldsValue({
            CustomerName: data.data.CustomerName
              ? String(data.data.CustomerName)
              : "",
            CustomerDesc: data.data.CustomerDesc
              ? String(data.data.CustomerDesc)
              : "",
            OemNo: data.data.OemNo ? data.data.OemNo : "",
            DealerNo: data.data.DealerNo ? data.data.DealerNo : "",
            MaxAccount: data.data.MaxAccount,
          });
          setSelectedOemNo(data.data.OemNo);
        } else {
          console.warn("No data found for the given ID");
        }
      } catch (error) {
        if (!loading) {
          console.log({ error });
          openErrorNotification("Error fetching data!");
        }
      }
    };

    getAccountInfoById();
  }, [id, data, loading, form, type]);

  //toat for create
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong",
      );
    } else if (!postLoading && !postError && postData) {
      openConfirmNotification("Success");
      setAccountDefaultData &&
        setAccountDefaultData((prev) => {
          return {
            ...prev,
            CustomerNo: postData?.data?.CustomerNo,
          };
        });
      setTimeout(() => {
        isModalForm
          ? onCancel()
          : navigate(
              postData?.data?.CustomerNo
                ? `/customer/info/${postData?.data?.CustomerNo}`
                : -1,
            );
      }, 400);
    }
  }, [postError, postData, postLoading]);

  //toat for update
  useEffect(() => {
    if (putError) {
      openErrorNotification(
        putError?.response?.data?.message || "Something went wrong",
      );
    } else if (!putLoading && !putError && putData) {
      openConfirmNotification("Success");
      refetch();
      setTimeout(() => {
        navigate(-1);
      }, 400);
    }
  }, [putData, putLoading, putError]);

  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
      // refetch();
      navigate("/customer");
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong",
      );
    }
  }, [deletedData, deletedDataError]);
  useEffect(() => {
    if (deletedAdminData && !deletedAdminDataError) {
      openConfirmNotification("Success");
      // refetch();
      adminDataRefetch();
    } else if (deletedAdminDataError) {
      openErrorNotification(
        deletedAdminDataError?.response?.data?.message ||
          "Something went wrong",
      );
    }
  }, [deletedAdminData, deletedAdminDataError]);

  useEffect(() => {
    delaerOpRefetch();
    if (accountDefaultData) {
      form.setFieldsValue(accountDefaultData);
    }
  }, [accountDefaultData]);

  //sent admin invitation
  const handleInvitation = (e) => {
    setIsModalOpen(true);
  };
  const breadcrumbItems = [
    {
      label: "Customer",
      href: "/customer",
    },
    {
      label: id ? (type === "info" ? "Information" : "Edit") : "Add",
      href: id
        ? type === "info"
          ? `/customer/info/${id}`
          : `/customer/edit/${id}`
        : "/customer/add",
    },
  ];

  const buttonsData =
    type === "info"
      ? [
          // Conditionally render the "Customer Invitation" button if adminInfo is available
          !adminInfo && {
            label: "Customer Invitation",
            icon: <SendOutlined />,
            onClick: handleInvitation,
          },
          {
            label: "Edit",
            icon: <EditOutlined />,
            onClick: () => {
              navigate(`/customer/edit/${id}`);
            },
          },
          {
            label: "Delete",
            icon: <DeleteOutlined />,
            onClick: () => {
              setShowModal(true);
            },
          },
          {
            label: "List",
            icon: <UnorderedListOutlined />,
            onClick: () => {
              navigate("/customer");
            },
          },
        ].filter(Boolean) // Remove undefined/null values
      : [
          {
            label: "Apply",
            icon: <CheckCircleOutlined />,
            onClick: () => form.submit(),
          },
          {
            label: "Cancel",
            icon: <CloseOutlined />,
            onClick: onReset,
          },
        ];

  const accountButtonsData = [
    {
      label: "Invite",
      icon: <SendOutlined />,
      onClick: () => setIsSendInviteOpen(true),
    },
    {
      label: "Add",
      icon: <PlusOutlined />,
      onClick: () => {
        setShowAccountModal(true);
      },
    },
    {
      label: "Delete",
      icon: <DeleteOutlined />,
      disabled: selectedRowKeys.length === 0,
      onClick: () => {
        setShowModal(true);
      },
    },
  ];

  const handleCreateNew = (type) => {
    setModalType(type);
    setIsOpenModal(true);
  };

  useEffect(() => {
    if (!id && [1, 2, 3].includes(loggedInUser?.role_value)) {
      form.setFieldsValue({
        MaxAccount: 5,
      });
    }
  }, [id]);
  useEffect(() => {
    optionDataRefetch();
    delaerOpRefetch();
    if (
      defaultData?.OemNo ||
      defaultData?.DealerNo ||
      defaultData?.CustomerNo
    ) {
      form.setFieldsValue(defaultData);
    } else if (
      accountDefaultData?.OemNo ||
      accountDefaultData?.DealerNo ||
      accountDefaultData?.CustomerNo
    ) {
      form.setFieldsValue(accountDefaultData);
    }
  }, [defaultData]);

  return (
    <div>
      <AccountCreationModal
        isOpenModal={isOpenModal}
        modalType={modalType}
        setIsOpenModal={setIsOpenModal}
        setDefaultData={setDefaultData}
        defaultData={defaultData}
        setModalType={setModalType}
        isModal={true}
        isModalForm={true}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            {modalType === "OEM" ? (
              <OemIcon className="text-[15px] text-black ml-1" />
            ) : modalType === "Dealer" ? (
              <DealerIcon className="text-[15px] text-black ml-1" />
            ) : null}
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              {isOpenModal ? `Add ${modalType}` : "Send Invitation"}
            </span>
          </div>
        }
      />
      <Form
        validateTrigger={"onChange"}
        form={form}
        onFinish={onFinish}
        scrollToFirstError
        layout={"vertical"}
        autoComplete={"off"}
      >
        <div>
          {!isModalForm && (
            <div className="pb-4 sticky -mt-4 pt-[6px] top-[55px] z-10 bg-[#f4f5f9]">
              <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
                <CommonButton buttonsData={buttonsData} />
              </CommonBreadcrumb>
            </div>
          )}
          {
            <div
              className={`bg-white overflow-hidden ${
                isModalForm ? "" : "border rounded-[4px] "
              }`}
            >
              {!isModalForm && (
                <div className="flex items-center bg-gray-200 p-2.5">
                  <AccountIcon className="text-[18px] text-black " />
                  <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                    Customer
                  </span>
                </div>
              )}
              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 8]}>
                  {/* </Row>
                  <Row gutter={[16, 16]}> */}
                  <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomInput
                      label="Name"
                      name="CustomerName"
                      disabled={type === "info"}
                      required
                      loading={loading}
                    />
                  </Col>
                  <Col
                    xs={!isModalForm && 24}
                    sm={!isModalForm && 24}
                    md={!isModalForm && 12}
                    lg={!isModalForm && 12}
                    xl={!isModalForm && 12}
                    span={24}
                  >
                    <CustomInput
                      label="Description"
                      name="CustomerDesc"
                      disabled={type === "info"}
                      loading={loading}
                    />
                  </Col>
                  {[1, 2, 3].includes(loggedInUser?.role_value) && (
                    <Col
                      xs={!isModalForm && 24}
                      sm={!isModalForm && 24}
                      md={!isModalForm && 12}
                      lg={!isModalForm && 12}
                      xl={!isModalForm && 12}
                      span={24}
                    >
                      <CustomInput
                        label="Max Account"
                        name="MaxAccount"
                        disabled={type === "info"}
                        // required
                        type="number"
                        loading={loading}
                      />
                    </Col>
                  )}
                  {![4, 5, 6, 7, 8, 9].includes(loggedInUser?.role_value) && (
                    <Col
                      xs={!isModalForm && 24}
                      sm={!isModalForm && 24}
                      md={!isModalForm && 12}
                      lg={!isModalForm && 12}
                      xl={!isModalForm && 12}
                      span={24}
                    >
                      {/* <CustomSelect
                        label="OEM"
                        name="OemNo"
                        options={modifiedOems}
                        placeholder="Please select"
                        onChange={(value) => {
                          setSelectedOemNo(value);
                          form.setFieldsValue({
                            DealerNo: "",
                          });
                        }}
                        disabled={type === "info"}
                        required
                      /> */}
                      <CustomSelect
                        label="OEM"
                        name="OemNo"
                        options={modifiedOems}
                        disabled={type === "info" || accountDefaultData?.OemNo}
                        placeholder="Please select"
                        onChange={(value) => {
                          setDefaultData((prev) => ({
                            ...prev,
                            OemNo: value,
                            DealerNo: "",
                          }));
                          setSelectedOemNo(value);
                          form.setFieldsValue({
                            DealerNo: "",
                          });
                        }}
                        required
                        handleCreateNew={
                          accountDefaultData?.OemNo ? null : handleCreateNew
                        }
                        type={"OEM"}
                        loading={loading}
                      />
                    </Col>
                  )}
                  {![7, 8, 9].includes(loggedInUser?.role_value) && (
                    <Col
                      xs={!isModalForm && 24}
                      sm={!isModalForm && 24}
                      md={!isModalForm && 12}
                      lg={!isModalForm && 12}
                      xl={!isModalForm && 12}
                      span={24}
                    >
                      {/* <CustomSelect
                        label="Dealer"
                        name="DealerNo"
                        options={
                          dealerOp?.data?.map((item) => ({
                            label: item.name,
                            value: item.value,
                          })) || []
                        }
                        placeholder="Please select"
                        disabled={type === "info"}
                        required
                      /> */}

                      <CustomSelect
                        label="Dealer"
                        name="DealerNo"
                        disabled={
                          // defaultData?.OemNo
                          //   ? !defaultData?.OemNo
                          //   : accountDefaultData?.OemNo
                          //   ? !accountDefaultData?.OemNo
                          //   : !selectedOemNo ||
                          type === "info" || defaultData?.OemNo
                            ? !defaultData?.OemNo
                            : !selectedOemNo
                        }
                        onChange={(value) => {
                          setDefaultData((prev) => ({
                            ...prev,
                            OemNo: selectedOemNo,
                            DealerNo: value,
                          }));
                        }}
                        options={
                          dealerOp?.data?.map((item) => ({
                            label: item.name,
                            value: item.value,
                          })) || []
                        }
                        placeholder="Please select"
                        required
                        handleCreateNew={
                          accountDefaultData?.DealerNo ? null : handleCreateNew
                        }
                        type={"Dealer"}
                        loading={loading}
                      />
                    </Col>
                  )}
                </Row>
              </div>
            </div>
          }
        </div>
      </Form>
      {isModalForm && (
        <div className="flex justify-center space-x-2 mt-2.5">
          <Button
            type="primary"
            className="mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium flex items-center "
            onClick={() => form.submit()}
          >
            <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
            <span className="">Apply</span>
          </Button>
          <Button className="reset-button" onClick={onReset}>
            <CloseOutlined />
            <span className="">Cancel</span>
          </Button>
        </div>
      )}
      {type === "info" && (
        <>
          <div className={`flex justify-between items-center my-2`}>
            <div className="flex">
              <span className="mr-2 text-[18px] text-black">
                <AccountIcon />
              </span>
              <span className="text-[.935rem] text-black font-['Poppins']">
                Customer Accounts
              </span>
            </div>

            <div className="flex justify-end mb-2">
              <CommonButton buttonsData={accountButtonsData} />
            </div>
          </div>
          <>
            <GlobalTable
              columns={CustomerAccountColumns(
                hoveredRow,
                setShowModal,
                setSelectedRowKeys,
                setAccountId,
                setShowAccountModal,
              )}
              dataSource={adminInfo}
              rowSelection={rowSelection}
              // onRow={onRow}
              onRow={(record, rowIndex) => {
                return {
                  onMouseEnter: () => setHoveredRow(rowIndex),
                  onMouseLeave: () => setHoveredRow(null),
                  ...onRow?.(record, rowIndex),
                };
              }}
              loading={adminDataLoading}
            />
          </>
        </>
      )}
      {/* {adminInfo && (
        <AccountForm
          adminInfo={adminInfo}
          title="Customer Admin"
          icon={<AccountIcon />}
          type={type}
        />
      )} */}
      <AccountCreationModal
        isOpenModal={showAccountModal && accountId === null}
        modalType={"AccountCreate"}
        setIsOpenModal={setShowAccountModal}
        defaultData={{
          OemNo: form.getFieldValue("OemNo"),
          DealerNo: form.getFieldValue("DealerNo"),
          CustomerNo: Number(id),
        }}
        isModal={true}
        isModalForm={true}
        refetch={adminDataRefetch}
        disableCustomerField={true}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            <AccountIcon className="text-[15px] text-black ml-1" />
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              Add Account
            </span>
          </div>
        }
      />
      <AccountCreationModal
        isOpenModal={showAccountModal && accountId !== null}
        modalType={"AccountEdit"}
        setIsOpenModal={setShowAccountModal}
        defaultData={{
          OemNo: form.getFieldValue("OemNo"),
          DealerNo: form.getFieldValue("DealerNo"),
          CustomerNo: Number(id),
          AccountNo: accountId,
        }}
        isModal={true}
        // isModalForm={true}
        refetch={adminDataRefetch}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            <AccountIcon className="text-[15px] text-black ml-1" />
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              Edit Account
            </span>
          </div>
        }
        setAccountId={setAccountId}
      />
      <ConfirmModal
        showModal={showModal}
        setShowModal={setShowModal}
        onDeleteConfirm={onDeleteConfirm}
      />
      <Modal
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            <SendOutlined className="text-[14px] text-black pl-1 " />
            <span className="text-[14px] font-[Poppins]   ml-2">
              <p>Send Invitation</p>
            </span>
          </div>
        }
        open={isModalOpen}
        closable={false}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={580}
        centered
        destroyOnClose
      >
        <AdminInvitation
          payload={{
            DealerNo,
            OemNo,
            AccountType: 10,
            CustomerNo: Number(id),
          }}
          setIsModalOpen={setIsModalOpen}
        />
      </Modal>
      <Modal
        afterClose={() => setInviteModalType("")}
        destroyOnClose={true}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            <SendOutlined className="text-[15px] text-black ml-1" />
            <span className="text-[14px] font-[Poppins] text-black ml-2">
              {isInviteNestedOpen
                ? `Add ${inviteModalType}`
                : "Send Invitation"}
            </span>
          </div>
        }
        open={isSendInviteOpen}
        closable={false}
        onCancel={() => setIsSendInviteOpen(false)}
        footer={null}
        width={580}
        centered
      >
        <SendInvitationForm
          setIsModalOpen={(val) => {
            setIsSendInviteOpen(val);
            if (!val) adminDataRefetch();
          }}
          isOpenModal={isInviteNestedOpen}
          setIsOpenModal={setIsInviteNestedOpen}
          setModalType={setInviteModalType}
          modalType={inviteModalType}
          isModalOpen={isSendInviteOpen}
          lockedHierarchy={{
            OemNo: OemNo || form.getFieldValue("OemNo"),
            DealerNo: DealerNo || form.getFieldValue("DealerNo"),
            CustomerNo: Number(id),
          }}
          accountTypeIds={[10, 11, 12]}
        />
      </Modal>
    </div>
  );
};
